import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { IConnectContact } from '@epicuro-next/data/connect';
import { ConnectionStatus } from '@epicuro-next/models/users';
import { detectBrowser } from '@epicuro-next/platform/browser-detection';
import {
  selectFirstThreeUserContactsState,
  selectIsConnectEnabled,
  selectNotificationsPermission,
  selectUserConnectionStatus,
  setCurrentUserContactState,
} from '@epicuro-next/state/connect-state';
import { Store } from '@ngrx/store';
import { Severity } from 'graphql-api/baskets-api-interfaces';
import { map } from 'rxjs/operators';

@Component({
  selector: 'epc-connect-business-contacts',
  templateUrl: './business-contacts.component.html',
  styleUrls: ['./business-contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConnectBusinessContactsComponent implements OnInit {
  @Output() public navigate = new EventEmitter();
  public contacts$ = this.store.select(selectFirstThreeUserContactsState);
  public showShowAllButton$ = this.contacts$.pipe(
    map((contacts) => contacts.length > 0),
  );
  public isChromeIOS = detectBrowser('isChrome') && detectBrowser('isIos');
  protected get show(): boolean {
    return !this.isChromeIOS;
  }
  public severity = Severity.Error;

  public notificationsNotAllowed$ = this.store
    .select(selectNotificationsPermission)
    .pipe(
      map((notificationsPermission) => notificationsPermission === 'denied'),
    );

  public connectEnabled$ = this.store
    .select(selectIsConnectEnabled)
    .pipe(map(Boolean));

  public userCalling$ = this.store
    .select(selectUserConnectionStatus)
    .pipe(
      map((connectionStatus) => connectionStatus === ConnectionStatus.ONCALL),
    );

  constructor(private store: Store) {}

  public go() {
    this.navigate.emit();
  }

  public setCurrentContact(contact: IConnectContact) {
    this.store.dispatch(setCurrentUserContactState({ contact }));
  }

  public ngOnInit(): void {}
}
